(function ($) {
	$('.nav-search-input').attr('size', function () {
		const placeholderLen = this.getAttribute('placeholder').length - 5;
		const maxSize = 18;
		if ($(window).width() < 576) {
			$(this).attr(
				'placeholder',
				getCurrentLang() === '/de/' ? 'Suche' : 'Search'
			);
		}
		return placeholderLen > maxSize ? placeholderLen : maxSize;
	});

	$('.change-language-button').on('click', function () {
		const languageMenu = $('div.navbar-language');
		languageMenu.toggleClass('show');
		languageMenu.attr('aria-expanded', languageMenu.hasClass('show'));
	});

	$('button.nav-menu').bind('click', function () {
		$('body').css('overflow', 'hidden');
		$('#overlay-menu').fadeIn(200, function () {
			$('#overlay-menu').addClass('show');
		});
	});

	function closeMenu() {
		$('body').css('overflow', 'auto');
		$('#overlay-menu').fadeOut(200, function () {
			$('#overlay-menu').removeClass('show');
		});
	}

	//close-button overlay-menu
	$('#overlay-menu .close-menu > div').on('click', closeMenu);
	$(document).on('keyup', function (e) {
		if (e.key === 'Escape') {
			// escape key maps to keycode `27`
			closeMenu();
		}
	});

	//beil laden mobile-button beim current menu verstecken
	$(
		'#overlay-menu .card-columns .card.current_menu .card-body button.mobile'
	).addClass('hide');
	//overlay-menu auf und zu klappen
	$('#overlay-menu .card-columns .card .card-body button.mobile').click(
		function () {
			if ($(window).width() <= 576) {
				if (
					!$(this)
						.closest('.card-body')
						.find('.submenu')
						.is(':visible')
				) {
					$(
						'#overlay-menu .card-columns .card .card-body .submenu'
					).slideUp();
					$(
						'#overlay-menu .card-columns .card .card-body button.mobile'
					).removeClass('hide');
					$(this).closest('.card-body').find('.submenu').slideDown();
					$(this)
						.closest('.card-body')
						.find('button.mobile')
						.addClass('hide');
				}
			}
		}
	);

	$(window).resize(function () {
		if ($(window).width() > 576) {
			$(
				'#overlay-menu .card-columns .card .card-body .submenu'
			).slideDown();
		}
	});
})(jQuery);
